module.exports = __webpack_public_path__ + "static/img/jn.46aaf38.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/jn.png
// module id = cgax
// module chunks = 0